<template>
    <component
        :is="type"
        :href="href"
        :to="to"
        :class="[getClasses]"
        @click="onClick"
        :disabled="disabled"
        class="btn"
    >
         <slot />
    </component>
</template>

<script>
export default {
    name: 'btn',
    props: {
        href: {
            type: String,
            default: null,
        },
        to: {
            type: String,
            default: null,
        },
        primary: {
            type: Boolean,
            default: false,
        },
        secondary: {
            type: Boolean,
            default: false,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
        outline: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        type() {
            if (this.href) {
                return 'a';
            } else if (this.to) {
                return 'router-link';
            } else {
                return 'button';
            }
        },

        getClasses() {
            return {
                'btn-default': !this.primary && !this.secondary,
                'btn-primary': this.primary,
                'btn-secondary': this.secondary,
                'btn-rounded': this.rounded,
                'btn-outline': this.outline,
                'btn-disabled': this.disabled,
            };
        },
    },
    methods: {
        onClick() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="scss" scoped>
.btn {
    color: #ffffff;
    min-width: 135px;
}

a:not([href]) {
    color: #ffffff !important;
}

.btn-rounded {
    border-radius: 30px !important;
}
</style>
